import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import dana from "../../../Assets/Projects/blog.png";

function DanaSentiment() {
  return (
    <ProjectDetailCard
      title="Sentiment Analysis of DANA Application Reviews"
      image={dana}
      screenshots={[dana, dana, dana]}
      description="
      This project applies Natural Language Processing (NLP) techniques to analyze user sentiments from DANA application reviews collected from the Google Play Store. The system performs text preprocessing, feature extraction using TF-IDF, and sentiment classification to identify positive, neutral, and negative opinions. The results provide valuable insights into user satisfaction, application performance, and areas for service improvement through interactive visualizations and evaluation metrics.
      "
      technologies={[
        "Python",
        "NLP",
        "Scikit-learn",
        "TF-IDF",
        "Pandas",
        "NumPy",
        "Google Play Scraper",
        "Matplotlib",
        "Jupyter",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={dana} alt="gallery1" />
          <img src={dana} alt="gallery2" />
          <img src={dana} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default DanaSentiment;
